<template>
  <div class="STDSDC02C02" ref="content">
    <div class="wrapper">
      <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
      <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      税理士事務所共通ヘッダ                                                                                          _/
        _/                                                                                                                    _/
      _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
      <HeaderNav menuflg="1" />
      <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
           _/                                                                                                                    _/
           _/      画面定義                                                                                                      _/
           _/                                                                                                                    _/
      _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
      <div class="body">
        <div class="inner">
          <div class="pankuzu">
            <ul>
              <li>
                <router-link class="ico-home" :to="{ name: 'STFMFM01C01' }"
                  >メインページ</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'STDSDC02C01' }"
                  >事業者情報</router-link
                >
              </li>
              <li>
                <span class="current">事業者情報の新規登録</span>
              </li>
            </ul>
          </div>
          <h1 class="h1">事業者情報の新規登録</h1>
          <!--
          ****  メッセージ表示領域 ****-->
          <p class="errMsg title-ico ico-warning" v-show="errors != ''">
            <ErrorMessage :errors="errors"></ErrorMessage>
          </p>
          <p class="lead">
            事業者情報を登録します。必要な情報を入力してください。
          </p>
          <!-- ******************************************************************
               *  事業者情報                                                    *
          ******************************************************************-->
          <div class="para">
            <h2 class="h3">事業者情報</h2>
            <!-- criteria -->
            <div class="criteria">
              <div class="frm-row">
                <span class="frm-label w-150px">
                  <strong>事業者コード</strong>
                </span>
                <span class="frm-label-required w-45px">必須</span>
                <input
                  title=" "
                  class="frm-text frm-size-s"
                  type="url"
                  ref="textInputBopCode"
                  maxlength="10"
                  v-model="bopCode"
                  v-bind:class="{ error: isErrorBopCode }"
                  tabindex="1"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 215px"
                v-show="errors_bopcode != ''"
              >
                <ErrorMessageCase :errors="errors_bopcode"></ErrorMessageCase>
              </p>
              <div class="frm-row">
                <span class="frm-label w-150px">
                  <strong>法人個人区分</strong>
                </span>
                <span class="frm-label w-45px"></span>
                <div
                  tabindex="2"
                  class="frm-toggle frm-size-m"
                  @keydown.left.stop.prevent="toggleRadio"
                  @keydown.right.stop.prevent="toggleRadio"
                >
                  <label
                    v-for="item in corporationDivisionArray"
                    :key="item.code"
                  >
                    <input
                      type="radio"
                      :value="item.code"
                      v-model="rdoCorporationDivision"
                    />
                    <span>{{ item.name }}</span>
                  </label>
                </div>
              </div>

              <div class="frm-row">
                <span class="frm-label w-150px">
                  <strong>事業者名</strong>
                </span>
                <span class="frm-label-required w-45px">必須</span>
                <input
                  type="text"
                  id="name"
                  class="frm-text frm-size-xxl"
                  maxlength="52"
                  v-model="bopName"
                  @input="handleBopNameInput"
                  :class="{ error: isErrorBopName }"
                  tabindex="3"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 215px"
                v-show="errors_bopName != ''"
              >
                <ErrorMessageCase :errors="errors_bopName"></ErrorMessageCase>
              </p>

              <div class="frm-row">
                <span class="frm-label w-150px">
                  <strong>事業者名（フリガナ）</strong>
                </span>
                <span class="frm-label w-45px"></span>
                <input
                  type="text"
                  id="kana"
                  class="frm-text frm-size-xxl"
                  maxlength="104"
                  v-model="bopNameKana"
                  :class="{ error: isErrorBopNameKana }"
                  tabindex="4"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 215px"
                v-show="errors_bopkana != ''"
              >
                <ErrorMessageCase :errors="errors_bopkana"></ErrorMessageCase>
              </p>

              <div class="frm-row">
                <span class="frm-label w-150px">
                  <strong>決算日</strong>
                </span>
                <span class="frm-label-required w-45px">必須</span>
                <input
                  title=" "
                  type="url"
                  class="frm-text frm-size-xs alignright"
                  v-model.number="closingMonth"
                  maxlength="2"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  :class="{ error: isErrorClosingMonth }"
                  :disabled="isClosingDisabled"
                  tabindex="5"
                />
                <span class="frm-unit">月</span>
                <input
                  title=" "
                  type="url"
                  class="frm-text frm-size-xs alignright"
                  v-model.number="closingDay"
                  maxlength="2"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  :class="{ error: isErrorClosingDay }"
                  :disabled="isClosingDisabled"
                  tabindex="6"
                />
                <span class="frm-unit">日</span>
              </div>
              <p
                class="errMsg"
                style="margin-left: 215px"
                v-show="errors_closing != ''"
              >
                <ErrorMessageCase :errors="errors_closing"></ErrorMessageCase>
              </p>
              <!-- 主担当者 -->
              <STDSDC02C09PersonInChargeModal
                ref="STDSDC02C09PersonInChargeModal"
                :tabindex="7"
                v-model="personInCharge"
                :personInChargeList="personInChargeList"
                :isChangeWidth="true"
              ></STDSDC02C09PersonInChargeModal>
            </div>
            <div class="frm-row" v-if="rdoCorporationDivision == 1">
              <span class="frm-label w-150px">
                <strong>法人番号</strong>
              </span>
              <span class="frm-label w-45px"></span>
              <input
                type="url"
                title=""
                class="frm-text frm-size-ms"
                maxlength="16"
                v-model="corporateNumbertemp"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                :class="{ error: isErrorCorporateNumber }"
                v-on:keydown.enter="onKeyEnter"
                tabindex="8"
              />
              <button
                class="frm-btn strong"
                type="button"
                @click="corporateNoSiteUrl"
                tabindex="9"
              >
                参照
              </button>
            </div>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="errors_corporatenumber != ''"
              v-if="rdoCorporationDivision == 1"
            >
              <ErrorMessageCase
                :errors="errors_corporatenumber"
              ></ErrorMessageCase>
            </p>
            <!-- 郵便番号 -->
            <div class="frm-row">
              <span class="frm-label w-150px">
                <strong>郵便番号</strong>
              </span>
              <span class="frm-label w-45px"></span>
              <input
                type="url"
                title=" "
                class="frm-text frm-size-postalCode3"
                maxlength="3"
                tabindex="10"
                v-model="this.zipCode1"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                :class="{
                  error: isZipCode1Error,
                }"
              />
              <span>　-&nbsp; </span>
              <input
                type="url"
                title=" "
                class="frm-text frm-size-postalCode4"
                maxlength="4"
                tabindex="11"
                v-model="this.zipCode2"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                :class="{ error: this.isErrorPostalCode4 }"
              />
              <button
                class="frm-btn strong"
                data-role="popup-open"
                data-target="#popup-address"
                @click="addressSearch()"
                tabindex="12"
              >
                参照
              </button>
            </div>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="this.errors_postalCode != ''"
            >
              <ErrorMessageCase
                :errors="this.errors_postalCode"
              ></ErrorMessageCase>
            </p>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="this.errors_oneRequired != ''"
            >
              <ErrorMessageCase
                :errors="this.errors_oneRequired"
              ></ErrorMessageCase>
            </p>
            <div class="frm-row">
              <span class="frm-label w-150px">
                <strong>所在地</strong>
              </span>
              <span class="frm-label w-45px"></span>
              <input
                type="text"
                id="address"
                class="frm-text frm-size-xxl"
                maxlength="80"
                v-model="this.address"
                @input="handleLocationInput"
                :class="{ error: isAddressError }"
                tabindex="13"
              />
            </div>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="errors_address != ''"
            >
              <ErrorMessageCase :errors="errors_address"></ErrorMessageCase>
            </p>

            <div class="frm-row">
              <span class="frm-label w-150px">
                <strong>所在地（フリガナ）</strong>
              </span>
              <span class="frm-label w-45px"></span>
              <input
                type="text"
                id="addressF"
                class="frm-text frm-size-xxl"
                maxlength="160"
                v-model="addressF"
                :class="{ error: isErrorAddressF }"
                tabindex="14"
              />
            </div>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="errors_addressF != ''"
            >
              <ErrorMessageCase :errors="errors_addressF"></ErrorMessageCase>
            </p>
            <div class="frm-row" v-if="rdoCorporationDivision == 1">
              <span class="frm-label w-150px">
                <strong>代表者氏名</strong>
              </span>
              <span class="frm-label w-45px"></span>
              <input
                class="frm-text frm-size-xxl"
                type="text"
                maxlength="80"
                tabindex="15"
                ref="textInputName"
                v-model="representativeName"
                v-bind:class="{ error: isErrorRepresentativeName }"
              />
            </div>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="
                rdoCorporationDivision == 1 && errors_RepresentativeName != ''
              "
            >
              <ErrorMessageCase
                :errors="errors_RepresentativeName"
              ></ErrorMessageCase>
            </p>
            <div class="frm-row" v-if="rdoCorporationDivision == 1">
              <span class="frm-label w-150px">
                <strong>代表者住所</strong>
              </span>
              <span class="frm-label w-45px"></span>
              <input
                class="frm-text frm-size-xxl"
                type="text"
                maxlength="160"
                tabindex="15"
                ref="textInputAddress"
                v-model="representativeAddress"
                v-bind:class="{ error: isErrorRepresentativeAddress }"
              />
            </div>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="
                rdoCorporationDivision == 1 &&
                errors_RepresentativeAddress != ''
              "
            >
              <ErrorMessageCase
                :errors="errors_RepresentativeAddress"
              ></ErrorMessageCase>
            </p>
            <!-- 所轄税務署 -->
            <STDSDC01C11TaxOfficeListModal
              ref="refSTDSDC01C11TaxOfficeListModal"
              v-model="this.competentTaxOffice"
              :address="checkAddress"
              :tabindex="15"
              :isChangeWidth="true"
            ></STDSDC01C11TaxOfficeListModal>
            <div class="frm-row" id="none02">
              <span class="frm-label w-150px">
                <strong>利用者識別番号(e-Tax)</strong>
              </span>
              <span class="frm-label w-45px"></span>
              <input type="text" style="display: none" />
              <input
                class="frm-text frm-size-l"
                type="text"
                ref="textInputE_taxUserID"
                maxlength="19"
                tabindex="16"
                v-model="formattedE_taxUserID"
                v-bind:class="{ error: isErrorE_taxUserID }"
                @input="formatE_taxUserID"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </div>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="errors_E_taxUserID != ''"
            >
              <ErrorMessageCase :errors="errors_E_taxUserID"></ErrorMessageCase>
            </p>
            <div class="frm-row" id="none03">
              <span class="frm-label w-150px">
                <strong>暗証番号(e-Tax)</strong>
              </span>
              <span class="frm-label" style="width: 51px"></span>
              <PasswordInput
                ref="password"
                tabindex="16"
                v-model="e_taxPassword"
                :hasError="isErrorE_taxPassword"
                v-on:keydown.enter="onKeyEnter"
              />
            </div>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="errors_E_taxPassword != ''"
            >
              <ErrorMessageCase
                :errors="errors_E_taxPassword"
              ></ErrorMessageCase>
            </p>
            <div class="frm-row">
              <span class="frm-label w-150px">
                <strong>利用者ID(eLTAX)</strong>
              </span>
              <span class="frm-label w-45px"></span>
              <input
                type="text"
                id="eLtaxId"
                class="frm-text frm-size-s"
                maxlength="11"
                v-model="eLtaxId"
                :class="{ error: isErrorELtaxId }"
                tabindex="16"
              />
            </div>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="errors_eLtaxId != ''"
            >
              <ErrorMessageCase :errors="errors_eLtaxId"></ErrorMessageCase>
            </p>
            <div class="frm-row errMsgToogle">
              <span class="frm-label w-150px">
                <strong>暗証番号(eLTAX)</strong>
              </span>
              <span class="frm-label" style="width: 51px"></span>
              <PasswordInput
                ref="password"
                v-model="eLtaxPassword"
                :maxLength="16"
                tabindex="16"
                :hasError="isErrorELtaxPassword"
                v-on:keydown.enter="onKeyEnter"
              />
            </div>
            <p
              class="errMsg"
              style="margin-left: 215px"
              v-show="errors_eLtaxPassword != ''"
            >
              <ErrorMessageCase
                :errors="errors_eLtaxPassword"
              ></ErrorMessageCase>
            </p>
          </div>
          <!-- ******************************************************************
               *  アクセス権限情報                                              *
          ******************************************************************-->
          <div class="para">
            <h2 class="h3">アクセス権限情報</h2>
            <!-- legend -->
            <div class="legend">
              <ul>
                <li>
                  <img
                    src="@/assets/images/TDSDC/icon_access-user.png"
                    width="19"
                    height="21"
                    alt
                  />
                  <strong>アクセス権限の設定が可能な利用者</strong>
                </li>
                <li>
                  <span
                    class="ico-tooltip"
                    v-tooltip="{
                      title: msgAccess,
                      position: 'top',
                    }"
                  >
                    <img
                      src="@/assets/images/TDSDC/icon_irai_help.png"
                      width="18"
                      height="20"
                      alt
                    />
                    {{ accessAuthDisplay }}
                  </span>
                </li>
              </ul>
            </div>
            <!-- legend // -->
            <p class="lead">利用者のアクセス権限を設定します。</p>
            <p class="sup-explanation">
              アクセスが許可されている利用者のみ、当事業者に係る情報にアクセスできます。
            </p>
            <div class="frm-row">
              <span class="frm-label">
                <strong>アクセス権限設定</strong>
              </span>
              <span class="frm-label w-45px"></span>
              <div
                class="frm-toggle frm-size-mxl"
                tabindex="16 "
                @keydown.left.stop.prevent="toggleRadioAccessPermission"
                @keydown.right.stop.prevent="toggleRadioAccessPermission"
              >
                <label>
                  <input
                    value="0"
                    v-model="isAccessPermission"
                    type="radio"
                    name="toggle6"
                  />
                  <span>すべての利用者を許可</span>
                </label>
                <label>
                  <input
                    value="1"
                    v-model="isAccessPermission"
                    type="radio"
                    name="toggle6"
                  />
                  <span>指定した利用者を許可</span>
                </label>
              </div>
            </div>
            <!-- swap -->
            <div class="legend mt-20px" v-show="isAccessPermission == 1">
              <h3 class="h4">アクセスを許可する利用者の設定</h3>
              <p class="sup-explanation">
                グループまたはユーザーのいずれかが許可されている場合にアクセス可能となります。
              </p>
            </div>
            <div class="swap-row" v-show="isAccessPermission == 1">
              <div class="swap-left">
                <div class="frm-row">
                  <div
                    class="frm-search frm-size-xl"
                    :class="[
                      searchKeyPermission ? showSearched : showUnsearched,
                    ]"
                  >
                    <span class="frm-label">
                      &nbsp;
                      <img src="@/assets/images/TDSDC/icon_search.png" />
                    </span>
                    <input
                      type="search"
                      class="frm-search-text"
                      placeholder="検索キーワード"
                      :disabled="
                        sortPermissionList.length === 0 && !searchKeyPermission
                      "
                      maxlength="255"
                      v-model.trim="searchKeyPermission"
                      tabindex="17"
                    />
                  </div>
                </div>
                <div class="frm-item alignright">
                  <p>{{ permissionCount }}</p>
                </div>
                <!-- table -->
                <div class="table-wrap" style="margin-top: 0px">
                  <div class="table-scroll-header">
                    <table class="table-select multi-select">
                      <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 170px" />
                        <col style="width: auto" />
                        <col style="width: 110px" />
                      </colgroup>
                      <thead>
                        <tr>
                          <!-- 全選択解除 -->
                          <th class="multi-select-item aligncenter">
                            <label class="frm-checkbox">
                              <input
                                type="checkbox"
                                :checked="isAllSelectedPermission"
                                @click="selectAllRowPermission"
                                :disabled="
                                  sortPermissionList.every((e) => !e.enabled) ||
                                  sortPermissionList.length === 0
                                "
                              />
                              <span
                                class="checkbox-item"
                                :tabindex="
                                  sortPermissionList.every((e) => !e.enabled) ||
                                  sortPermissionList.length === 0
                                    ? null
                                    : 21
                                "
                                @keydown.space.stop.prevent="
                                  selectAllRowPermission
                                "
                              ></span>
                            </label>
                          </th>
                          <th
                            class="sort hover alignleft"
                            @click="sortPermissionData('id')"
                          >
                            ログインID/
                            <br />グループコード
                            <div class="sort-toggle">
                              <button
                                class="sort-toggle-asc"
                                :class="
                                  sortPermission.key == 'id' &&
                                  sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                                tabindex="21"
                              >
                                asc
                              </button>
                              <button
                                class="sort-toggle-desc"
                                :class="
                                  sortPermission.key == 'id' &&
                                  !sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                                tabindex="21"
                              >
                                desc
                              </button>
                            </div>
                          </th>
                          <th
                            class="sort hover alignleft"
                            @click="sortPermissionData('name')"
                          >
                            利用者/名称
                            <div class="sort-toggle">
                              <button
                                class="sort-toggle-asc"
                                :class="
                                  sortPermission.key == 'name' &&
                                  sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                                tabindex="21"
                              >
                                asc
                              </button>
                              <button
                                class="sort-toggle-desc"
                                :class="
                                  sortPermission.key == 'name' &&
                                  !sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                                tabindex="21"
                              >
                                desc
                              </button>
                            </div>
                          </th>
                          <th
                            class="sort hover"
                            @click="sortPermissionData('authority')"
                          >
                            権限
                            <div class="sort-toggle">
                              <button
                                class="sort-toggle-asc"
                                tabindex="21"
                                :class="
                                  sortPermission.key == 'authority' &&
                                  sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                              >
                                asc
                              </button>
                              <button
                                class="sort-toggle-desc"
                                tabindex="21"
                                :class="
                                  sortPermission.key == 'authority' &&
                                  !sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                              >
                                desc
                              </button>
                            </div>
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="table-scroll-body h-395px">
                    <table class="table-select multi-select">
                      <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 170px" />
                        <col style="width: auto" />
                        <col style="width: 110px" />
                      </colgroup>
                      <tbody>
                        <tr
                          v-for="info in sortPermissionList"
                          :key="info.id"
                          @click="selectRow(info)"
                          :class="{
                            selected: info.selected,
                            disabled: !info.enabled,
                          }"
                        >
                          <!-- 選択 -->
                          <td class="multi-select-item aligncenter">
                            <label
                              class="frm-checkbox"
                              @keydown.space.stop.prevent="selectRow(info)"
                            >
                              <!-- 収集方法が対象外の場合は非活性-->
                              <input
                                type="checkbox"
                                :checked="info.selected"
                                @click="selectRow(info)"
                                :disabled="info.enabled == false"
                              />
                              <span
                                class="checkbox-item"
                                :tabindex="info.enabled == false ? null : 21"
                              ></span>
                            </label>
                          </td>
                          <td
                            class="group"
                            :class="{
                              'ico-folder': info.icon,
                              'ico-user': !info.icon,
                            }"
                          >
                            <span>{{ info.id }}</span>
                          </td>
                          <td>
                            <span>{{ info.name }}</span>
                          </td>
                          <td class="aligncenter">
                            <span>
                              {{ accessAuthFormat(info.authority) }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      class="table-select single-select"
                      style="background: #fff"
                      v-show="sortPermissionList.length === 0"
                    >
                      <tbody>
                        <tr>
                          <p class="noData-area">
                            {{ noDataMsg }}
                          </p>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- table // -->
              </div>
              <div class="swap-center">
                <div class="swap-btn-col">
                  <button
                    class="swap-btn permission"
                    type="button"
                    @click="handlePermission"
                    :disabled="!sortDeniedList.some((e) => e.selected)"
                    tabindex="21"
                  >
                    許可
                  </button>
                  <button
                    class="swap-btn rejection"
                    type="button"
                    @click="handleDenied"
                    :disabled="!sortPermissionList.some((e) => e.selected)"
                    tabindex="21"
                  >
                    拒否
                  </button>
                </div>
              </div>
              <div class="swap-right">
                <div class="frm-row">
                  <div
                    class="frm-search frm-size-xl"
                    :class="[searchKeyDenied ? showSearched : showUnsearched]"
                  >
                    <span class="frm-label">
                      &nbsp;
                      <img src="@/assets/images/TDSDC/icon_search.png" />
                    </span>
                    <input
                      type="search"
                      class="frm-search-text"
                      placeholder="検索キーワード"
                      v-model.trim="searchKeyDenied"
                      :disabled="
                        sortDeniedList.length === 0 && !searchKeyDenied
                      "
                      maxlength="255"
                      tabindex="21"
                    />
                  </div>
                </div>
                <!-- table -->
                <div class="frm-item alignright">
                  <p>{{ deniedCount }}</p>
                </div>
                <div class="table-wrap" style="margin-top: 0px">
                  <div class="table-scroll-header">
                    <table class="table-select scroll">
                      <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 170px" />
                        <col style="width: auto" />
                        <col style="width: 110px" />
                      </colgroup>
                      <thead>
                        <tr>
                          <!-- 全選択解除 -->
                          <th class="multi-select-item aligncenter">
                            <label class="frm-checkbox">
                              <input
                                type="checkbox"
                                :checked="isAllSelectedDenied"
                                @click="selectAllRowDenied"
                                :disabled="sortDeniedList.length === 0"
                              />
                              <span
                                class="checkbox-item"
                                :tabindex="
                                  sortDeniedList.length === 0 ? null : 21
                                "
                                @keydown.space.stop.prevent="selectAllRowDenied"
                              ></span>
                            </label>
                          </th>
                          <th
                            class="sort hover alignleft"
                            @click="sortDeniedData('id')"
                          >
                            ログインID/
                            <br />グループコード
                            <div class="sort-toggle">
                              <button
                                class="sort-toggle-asc"
                                :class="
                                  sortDenied.key == 'id' && sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                                tabindex="21"
                              >
                                asc
                              </button>
                              <button
                                class="sort-toggle-desc"
                                :class="
                                  sortDenied.key == 'id' && !sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                                tabindex="21"
                              >
                                desc
                              </button>
                            </div>
                          </th>
                          <th
                            class="sort hover alignleft"
                            @click="sortDeniedData('name')"
                          >
                            利用者/名称
                            <div class="sort-toggle">
                              <button
                                class="sort-toggle-asc"
                                :class="
                                  sortDenied.key == 'name' && sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                                tabindex="21"
                              >
                                asc
                              </button>
                              <button
                                class="sort-toggle-desc"
                                :class="
                                  sortDenied.key == 'name' && !sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                                tabindex="21"
                              >
                                desc
                              </button>
                            </div>
                          </th>
                          <th
                            class="sort hover"
                            @click="sortDeniedData('authority')"
                          >
                            権限
                            <div class="sort-toggle">
                              <button
                                class="sort-toggle-asc"
                                tabindex="21"
                                :class="
                                  sortDenied.key == 'authority' &&
                                  sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                              >
                                asc
                              </button>
                              <button
                                class="sort-toggle-desc"
                                tabindex="21"
                                :class="
                                  sortDenied.key == 'authority' &&
                                  !sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                "
                                type="button"
                              >
                                desc
                              </button>
                            </div>
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="table-scroll-body h-395px">
                    <table class="table-select scroll">
                      <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 170px" />
                        <col style="width: auto" />
                        <col style="width: 110px" />
                      </colgroup>
                      <tbody>
                        <tr
                          v-for="info in sortDeniedList"
                          :key="info.id"
                          @click="selectRow(info)"
                          :class="{
                            selected: info.selected,
                            disabled: !info.enabled,
                          }"
                        >
                          <!-- 選択 -->
                          <td class="multi-select-item aligncenter">
                            <label
                              class="frm-checkbox"
                              @keydown.space.stop.prevent="selectRow(info)"
                            >
                              <!-- 収集方法が対象外の場合は非活性-->
                              <input
                                type="checkbox"
                                :checked="info.selected"
                                @click="selectRow(info)"
                                :disabled="!info.enabled"
                              />
                              <span
                                class="checkbox-item"
                                :tabindex="!info.enabled ? null : 21"
                              ></span>
                            </label>
                          </td>
                          <td
                            class="group"
                            :class="{
                              'ico-folder': info.icon,
                              'ico-user': !info.icon,
                            }"
                          >
                            <span>{{ info.id }}</span>
                          </td>
                          <td>
                            <span>{{ info.name }}</span>
                          </td>
                          <td class="aligncenter">
                            <span>
                              {{ accessAuthFormat(info.authority) }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      class="table-select single-select"
                      style="background: #fff"
                      v-show="sortDeniedList.length === 0"
                    >
                      <tbody>
                        <tr>
                          <p class="noData-area">
                            {{ noDataMsg }}
                          </p>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- table // -->
              </div>
            </div>
            <!-- swap // -->
          </div>
          <!-- table // -->
          <!-- ******************************************************************
               *  税理士事務所メールアドレス情報                                        *
          ******************************************************************-->
          <div class="para">
            <h2 class="h3">税理士事務所メールアドレス情報</h2>
            <p class="lead newline">
              {{ notimessage }}
            </p>
            <!-- table -->
            <div class="table-wrap">
              <table class="table-select w-50per">
                <colgroup>
                  <col style="width: 600px" />
                  <col style="width: 480px" />
                  <col style="width: 80px" />
                </colgroup>
                <thead>
                  <tr>
                    <th class="alignleft">メールアドレス</th>
                    <th class="alignleft">宛先名</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(info, i) in mailAddressList" :key="info.id">
                    <td>
                      <input
                        title=" "
                        type="url"
                        class="frm-text frm-size-full"
                        maxlength="255"
                        v-model="mailAddressList[i].Address"
                        :class="{ error: isErrorNotifyMail[i] }"
                        tabindex="29"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="frm-text frm-size-full"
                        maxlength="100"
                        v-model="mailAddressList[i].DisplayName"
                        tabindex="29"
                      />
                    </td>
                    <td class="aligncenter">
                      <button
                        class="frm-btn-operation ico ico-delete"
                        type="button"
                        @click="handleDeleteNotify(i)"
                        tabindex="29"
                      >
                        削除
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- table // -->
            <p class="errMsg" v-show="errors_mailAdd != ''">
              <ErrorMessageCase :errors="errors_mailAdd"></ErrorMessageCase>
            </p>
            <div class="frm-row">
              <button
                class="frm-btn ico ico-plus strong large"
                type="button"
                @click="handleAddNotify"
                tabindex="30"
              >
                メールアドレスの追加
              </button>
            </div>
          </div>
          <!-- ******************************************************************
               *  下部ボタン群                                                  *
          ******************************************************************-->
          <div class="frm-btn-row footer-btn">
            <div class="frm-item grow center">
              <button
                class="frm-btn strong large"
                type="button"
                :disabled="isDisabled"
                @click="handleAdd"
                tabindex="31"
              >
                登録
              </button>
              <button
                class="frm-btn large"
                type="button"
                @click="$redirect({ name: 'STDSDC02C01' })"
                tabindex="32"
              >
                キャンセル
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      ダイアログ定義：前画面へ戻る際の確認ダイアログ
        _/      住所一覧画面(STDSDC01C12AddressListModal)                                                              _/
        _/                                                                                                                    _/
  _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
  <ConfirmDialog
    :isShow="isShow"
    :message="content"
    @confirm="confirm"
    @cancel="cancel"
  ></ConfirmDialog>
  <STDSDC01C12AddressListModal
    :isShow="this.isAddressListModalShow"
    :addressList="addressList"
    @confirm="confirmSTDSDC01C12"
    @cancel="cancelSTDSDC01C12"
  ></STDSDC01C12AddressListModal>
</template>

<script>
import { mapMutations } from "vuex";
import HeaderNav from "@/components/AccountingHeader.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import PasswordInput from "@/components/PasswordInput.vue";
import Validation from "@/util/validation.js";
import { ACCESS_AUTH } from "@/util/enum.js";
import { CORPORATION_DIVISION_LIST } from "@/util/data.js";
import Common from "@/util/common.js";
import { onlyKatakana, onlyKatakanaAndFullWithNumber } from "@/util/Kuroshiro";
import STDSDC02C09PersonInChargeModal from "@/components/STDSDC02C09PersonInChargeModal.vue";
import STDSDC01C11TaxOfficeListModal from "@/components/STDSDC01C11TaxOfficeListModal.vue";
import STDSDC01C12AddressListModal from "@/components/STDSDC01C12AddressListModal.vue";
import {
  API_Initialize,
  API_AddBopInfo,
} from "@/api/Modules/DC02/STDSDC02C02.js";
import { API_SearchAddressList_NetCommon } from "@/api/Modules/CM04/STDSCM04C00";

export default {
  name: "STDSDC02C02",
  components: {
    HeaderNav,
    ConfirmDialog,
    ErrorMessage,
    ErrorMessageCase,
    PasswordInput,
    STDSDC02C09PersonInChargeModal,
    STDSDC01C11TaxOfficeListModal,
    STDSDC01C12AddressListModal,
  },
  data() {
    return {
      selectCountPermission: 0,
      showSelectCountPermission: false,
      selectCountDenied: 0,
      showCountDenied: true,
      showSelectCountDenied: false,
      noDataMsg: Common.getMessage("MTCL1118", ["利用者"]),
      showSearched: "frm-search frm-size-xl setvalue",
      showUnsearched: "frm-search frm-size-xl",
      rdoCorporationDivision: 1, // 法人個人区分選択値
      bopCode: "", // 事業者コード
      bopName: "", // 事業者名
      bopNameKana: "", // 事業者名（フリガナ）
      closingMonth: "", // 決算日(月)
      closingDay: "", // 決算日(日)
      corporateNumber: "", //法人番号
      corporateNumbertemp: "", //法人番号表示
      zipCode1: "", //郵便番号3桁
      zipCode2: "", //郵便番号4桁
      address: "", // 所在地
      addressF: "", // 所在地（フリガナ）
      representativeName: "", // 代表者氏名
      representativeAddress: "", // 代表者住所
      e_taxUserID: "", // 利用者識別番号(e-Tax)
      e_taxPassword: "", // 暗証番号(e-Tax)
      eLtaxId: "", // 利用者ID(eLTAX)
      eLtaxPassword: "", // 暗証番号(eLTAX)
      competentTaxOffice: "", //所轄税務署
      searchKeyPermission: "", // アクセス許可フィルタテキスト
      highlightsPermission: [],
      highlightPermissionIndex: -1,
      searchKeyDenied: "", // アクセス拒否フィルタテキスト
      highlightsDenied: [],
      highlightDeniedIndex: -1,
      authorityInfoList: [], // アクセス許可リスト
      deniedData: [], // アクセス拒否リスト
      // 通知先メールアドレス
      mailAddressList: [
        {
          Address: "",
          DisplayName: "",
        },
      ],
      isErrorNotifyMail: [false], // 通知先メールアドレス_エラー表示
      isErrorClosingMonth: false, // 決算日（月）_エラー表示
      isErrorClosingDay: false, // 決算日（日）_エラー表示
      isErrorPersonInCharge: false, // 主担当者_エラー制御
      isErrorBopCode: false, // 事業者コード_エラー表示
      isErrorBopName: false, // 事業者名_エラー表示
      isErrorBopNameKana: false, // 事業者名（フリガナ）_エラー表示
      isErrorCorporateNumber: false, // 法人番号_エラー表示
      isErrorPostalCode3: false, // 郵便番号3桁_エラー表示
      isErrorPostalCode4: false, // 郵便番号4桁_エラー表示
      isErrorOneRequired: false, // 郵便番号3桁所在地_エラー表示
      isErrorAddress: false, // 所在地_エラー表示
      isErrorAddressF: false, // 所在地（フリガナ）_エラー表示
      isErrorRepresentativeName: false, // 代表者氏名_エラー表示
      isErrorRepresentativeAddress: false, // 代表者住所_エラー表示
      isErrorE_taxUserID: false, // 利用者識別番号(e-Tax)_エラー表示
      isErrorE_taxPassword: false, // 暗証番号(e-Tax)_エラー表示
      isErrorELtaxId: false, // 利用者ID(eLTAX)_エラー表示
      isErrorELtaxPassword: false, // 暗証番号(eLTAX)_エラー表示
      isErrorCompetentTaxOffice: false, // 所轄税務署_エラー制御
      errors: [], // エラー情報
      errors_bopcode: [], // エラー情報_事業者コード
      errors_bopkana: [], // エラー情報_事業者名カナ
      errors_bopName: [], // エラー情報_事業者名
      errors_closing: [], // エラー情報_決算日
      errors_corporatenumber: [], // エラー情報_法人番号
      errors_postalCode: [], // エラー情報_郵便番号
      errors_oneRequired: [], // エラー情報_郵便番号3桁所在地_
      errors_addressF: [], // エラー情報_所在地カナ
      errors_RepresentativeName: [], // エラー情報_代表者氏名
      errors_RepresentativeAddress: [], // エラー情報_代表者住所
      errors_E_taxUserID: [], // エラー情報_利用者識別番号(e-Tax)
      errors_E_taxPassword: [], // エラー情報_暗証番号(e-Tax)
      errors_eLtaxPassword: [], // エラー情報_暗証番号(eLTAX)
      errors_eLtaxId: [], // エラー情報_利用者ID(eLTAX)
      errors_address: [], // エラー情報_所在地
      errors_mailAdd: [], // エラー情報_メールアドレス
      sortPermission: {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      sortDenied: {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      msgAccess: Common.getMessage("MTCL2039", []), // アクセス権限のツールチップ表示メッセージ
      isSelectDivision: null, // 許可リスト、拒否リストのどちらを選択しているか null:未選択 true:許可リスト false:拒否リスト
      isShow: false, // 遷移提示表示
      content: "", // メッセージ
      toRouter: "", // 遷移先画面
      accessAuthDisplay: [], // アクセス権限の設定が可能なユーザー
      workgroupList: [], // ワークグループリスト
      userList: [], // ユーザーリスト
      isDisabled: false,
      permissionDataCope: [], // アクセス許可リスト_コッピ
      deniedDataCope: [], // アクセス拒否リスト_コッピ
      isSearchKeyEnter: false,
      notimessage: "", // 通知先情報メッセージ
      isCheckClosingDate: true, // 決算日相関チェックフラグ
      personInCharge: "", //主担当者ID
      personInChargeList: [],
      addressList: [], //郵便番号リスト
      isAddressListModalShow: false, //郵便番号参照画面制御
      isAccessPermission: 0, //アクセス権限設定フラグ
    };
  },
  created() {
    // 画面遷移チェック用メッセージ初期化
    this.content = Common.getMessage("MTCL2001", []);
    // 通知先情報メッセージ初期化
    this.notimessage = Common.getMessage("MTFM8060", []);
  },
  mounted() {
    this.processDialogue(true);

    // 事業者情報登録画面の初期処理
    API_Initialize().then((response) => {
      this.personInChargeList = [...response.authorityInfoList].filter(
        (e) => !e.icon
      );
      this.authorityInfoList = response.authorityInfoList.map((e) => {
        return { ...e, permission: true, selected: false };
      });
      this.accessAuthDisplay = response.accessAuthDisplay;
      this.workgroupList = response.workgroupList ? response.workgroupList : [];
      this.userList = response.userList ? response.userList : [];
      this.isSearchKeyEnter = true;

      // アクセス権限許可ユーザリストの選択リスト初期化
      this.authorityInfoList.forEach((value, index, array) => {
        // ソート用にシーケンスを付与
        if (array[index].icon) {
          array[index].sortSequence = 0;
        } else {
          array[index].sortSequence = 1;
        }
      });
      this.permissionDataCope = [...this.authorityInfoList];
      this.processDialogue(false);
    });
    // 初期フォーカス設定(事業者コード)
    this.$nextTick(() => this.$refs.textInputBopCode.focus());
  },

  // beforeUpdate() {
  //   var $tooltip = $("[data-tooltip]");
  //   $tooltip.on("mouseover", Common.showTooltip);
  //   $tooltip.on("mouseout", Common.hideTooltip);
  // },
  beforeRouteLeave(to, from, next) {
    // 画面遷移チェック
    if (
      !this.$cookies.get("SessionID") ||
      to.name == "STDSCM04C06" ||
      this.toRouter
    ) {
      next();
    } else {
      this.toRouter = to;
      this.isShow = true;
    }
  },
  watch: {
    rdoCorporationDivision: function (newVal) {
      // 決算日のエラー状態を初期化
      this.isErrorClosingMonth = false;
      this.isErrorClosingDay = false;

      // 法人の場合
      if (newVal === 1) {
        this.closingMonth = "";
        this.closingDay = "";
      }
      // 個人の場合
      else if (newVal === 2) {
        this.closingMonth = 12;
        this.closingDay = 31;
      }
    },
    // //所在地の変化を検知し所在地（フリガナ）を変更
    // async address(newValue) {
    //   this.addressF = "";
    //   this.addressF = await onlyKatakana(newValue);
    // },
    //corpCodetempの変化を検知してプロダクトコードを整形する
    corporateNumbertemp(newValue, oldValue) {
      this.corporateNumber = newValue;

      let temValue = newValue.trim().replace(/-/g, "");
      //法人番号入力有無チェック
      //法人番号を貼り付けするチェック
      if (newValue.length < oldValue.length && temValue.length != 13) {
        return;
      }
      if (temValue.length <= 1) {
        this.corporateNumbertemp = temValue + "-";
      } else if (temValue.length > 1 && temValue.length < 5) {
        this.corporateNumbertemp =
          temValue.substring(0, 1) +
          "-" +
          temValue.substring(1, temValue.length);
      } else if (temValue.length >= 5 && temValue.length < 9) {
        this.corporateNumbertemp =
          temValue.substring(0, 1) +
          "-" +
          temValue.substring(1, 5) +
          "-" +
          temValue.substring(5, temValue.length);
      } else {
        this.corporateNumbertemp =
          temValue.substring(0, 1) +
          "-" +
          temValue.substring(1, 5) +
          "-" +
          temValue.substring(5, 9) +
          "-" +
          temValue.substring(9, temValue.length);
      }
    },
  },
  computed: {
    permissionCount() {
      const total = this.authorityInfoList.filter((e) => e.permission).length;
      return this.searchKeyPermission
        ? `${this.sortPermissionList.length.toLocaleString()}/${total.toLocaleString()}件`
        : `${total.toLocaleString()}件`;
    },
    deniedCount() {
      const total = this.authorityInfoList.filter((e) => !e.permission).length;
      return this.searchKeyDenied
        ? `${this.sortDeniedList.length.toLocaleString()}/${total.toLocaleString()}件`
        : `${total.toLocaleString()}件`;
    },
    isAllSelectedDenied() {
      return (
        this.sortDeniedList.every((e) => !e.enabled) ||
        this.sortDeniedList
          .filter((e) => e.enabled)
          .every((info) => info.selected)
      );
    },
    isAllSelectedPermission() {
      return (
        this.sortPermissionList.every((e) => !e.enabled) ||
        this.sortPermissionList
          .filter((e) => e.enabled)
          .every((info) => info.selected)
      );
    },
    // 法人個人区分の設定
    corporationDivisionArray() {
      return CORPORATION_DIVISION_LIST.filter((el) => el.code != 0);
    },
    // 決算日の活性状態制御
    isClosingDisabled() {
      return this.rdoCorporationDivision === 2 ? true : false;
    },
    // 許可リストのソート
    sortPermissionList() {
      let list = this.authorityInfoList.filter((e) => e.permission);

      //検索キーワード

      list = list.filter((item) => {
        return (
          item.id.includes(this.searchKeyPermission) ||
          item.name.includes(this.searchKeyPermission) ||
          this.accessAuthFormat(item.authority).includes(
            this.searchKeyPermission
          )
        );
      });

      list = Common.listSort(
        this.sortPermission.key,
        this.sortPermission.isAsc,
        list
      );

      return list;
    },
    // 拒否リストのソート
    sortDeniedList() {
      let list = this.authorityInfoList.filter((e) => !e.permission);

      //検索キーワード

      list = list.filter((item) => {
        return (
          item.id.includes(this.searchKeyDenied) ||
          item.name.includes(this.searchKeyDenied) ||
          this.accessAuthFormat(item.authority).includes(this.searchKeyDenied)
        );
      });

      list = Common.listSort(this.sortDenied.key, this.sortDenied.isAsc, list);

      return list;
    },
    //郵便番号エラー表示
    isZipCode1Error() {
      return this.isErrorPostalCode3 || this.isErrorOneRequired ? true : false;
    },
    //所在地エラー表示
    isAddressError() {
      return this.isErrorAddress || this.isErrorOneRequired ? true : false;
    },
    checkAddress() {
      return this.address ? this.address : "";
    },
    isTopErrorShow() {
      return !this.isErrorNotifyMail.every((x) => !x) || // 通知先メールアドレス_エラー表示(一つtrueがあれば全体trueになる)
        this.isErrorClosingMonth || // 決算日（月）_エラー表示
        this.isErrorClosingDay || // 決算日（日）_エラー表示
        this.isErrorPersonInCharge || // 主担当者_エラー表示
        this.isErrorBopCode || // 事業者コード_エラー表示
        this.isErrorBopName || // 事業者名_エラー表示
        this.isErrorBopNameKana || // 事業者名（フリガナ）_エラー表示
        this.isErrorCorporateNumber || // 法人番号_エラー表示
        this.isErrorPostalCode3 || // 郵便番号3桁_エラー表示
        this.isErrorPostalCode4 || // 郵便番号4桁_エラー表示
        this.isErrorOneRequired || // 郵便番号3桁所在地_エラー表示
        this.isErrorAddress || // 所在地_エラー表示
        this.isErrorAddressF || // 所在地（フリガナ）_エラー表示
        this.isErrorELtaxId || // 利用者ID(eLTAX)_エラー表示
        this.isErrorCompetentTaxOffice // 所在地（フリガナ）_エラー表示所轄税務署
        ? true
        : false;
    },
    formattedE_taxUserID: {
      get() {
        return this.formatWithHyphens(this.e_taxUserID);
      },
      set(value) {
        this.e_taxUserID = value.replace(/-/g, "");
      },
    },
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue"]),
    // 全行選択時の処理
    selectAllRowDenied() {
      if (this.isAllSelectedDenied) {
        this.sortDeniedList
          .filter((e) => e.enabled)
          .forEach((info) => {
            // if (info.status != 99) {
            info.selected = false;
            // }
          });
      } else {
        this.sortDeniedList
          .filter((e) => e.enabled)
          .forEach((info) => {
            // if (info.status != 99) {
            info.selected = true;
            // }
          });
      }
    },

    // 全行選択時の処理
    selectAllRowPermission() {
      if (this.isAllSelectedPermission) {
        this.sortPermissionList
          .filter((e) => e.enabled)
          .forEach((info) => {
            // if (info.status != 99) {
            info.selected = false;
            // }
          });
      } else {
        this.sortPermissionList
          .filter((e) => e.enabled)
          .forEach((info) => {
            // if (info.status != 99) {
            info.selected = true;
            // }
          });
      }
    },
    confirm() {
      // 遷移チェック：「OK」
      this.isShow = false;
      this.$redirect(this.toRouter);
    },
    cancel() {
      // 遷移チェック：「キャンセル」
      this.isShow = false;
      this.toRouter = "";
    },

    sortPermissionData(key) {
      // isAsc 昇順ならtrue,降順ならfalse
      this.sortPermission.isAsc =
        this.sortPermission.key === key ? !this.sortPermission.isAsc : true;
      this.sortPermission.key = key;
    },

    sortDeniedData(key) {
      // isAsc 昇順ならtrue,降順ならfalse
      this.sortDenied.isAsc =
        this.sortDenied.key === key ? !this.sortDenied.isAsc : true;
      this.sortDenied.key = key;
    },
    // 行選択
    selectRow(info) {
      // 管理権限ユーザー以外の場合
      if (info.enabled) {
        info.selected = !info.selected;
      }
    },
    // フリガナを入力する
    async handleBopNameInput() {
      let katakana = await onlyKatakana(this.bopName);
      const maxLengthKataKana = String(katakana).slice(0, 104);
      this.bopNameKana = "";
      this.bopNameKana = maxLengthKataKana;
    },
    // フリガナを入力する
    async handleLocationInput() {
      let katakana = await onlyKatakanaAndFullWithNumber(this.address);
      const maxLengthKataKana = String(katakana).slice(0, 160);
      this.addressF = "";
      this.addressF = maxLengthKataKana;
    },

    // **********************************************
    // 検索アイコンをクリック時、該当する部分の色を変える_アクセス許可リスト
    // **********************************************
    searchNextPermission() {
      if (this.highlightsPermission.length > 0) {
        let targetIndex = this.highlightPermissionIndex;
        const maxIndex = this.highlightsPermission.length - 1;

        targetIndex++;

        if (targetIndex > maxIndex) {
          targetIndex = 0;
        }

        this.highlightPermissionIndex = targetIndex;

        for (let i = 0; i < this.highlightsPermission.length; i++) {
          const target = this.highlightsPermission[i];

          target.classList.remove("currentHighlight");

          if (i === targetIndex) {
            target.classList.add("currentHighlight");
          }
        }
      }
    },
    // **********************************************
    // 検索アイコンをクリック時、該当する部分の色を変える_アクセス拒否リスト
    // **********************************************
    searchNextDenied() {
      if (this.highlightsDenied.length > 0) {
        let targetIndex = this.highlightDeniedIndex;
        const maxIndex = this.highlightsDenied.length - 1;

        targetIndex++;

        if (targetIndex > maxIndex) {
          targetIndex = 0;
        }

        this.highlightDeniedIndex = targetIndex;

        for (let i = 0; i < this.highlightsDenied.length; i++) {
          const target = this.highlightsDenied[i];

          target.classList.remove("currentHighlight");

          if (i === targetIndex) {
            target.classList.add("currentHighlight");
          }
        }
      }
    },
    // アクセス権限フォーマット
    accessAuthFormat(data) {
      // グループ
      if (data == ACCESS_AUTH.group.code) {
        return ACCESS_AUTH.group.text;
      }
      // 管理者
      else if (data == ACCESS_AUTH.admin.code) {
        return ACCESS_AUTH.admin.text;
      }
      // 管理ユーザー
      else if (data == ACCESS_AUTH.adminUser.code) {
        return ACCESS_AUTH.adminUser.text;
      }
      // 一般ユーザー
      else if (data == ACCESS_AUTH.generalUser.code) {
        return ACCESS_AUTH.generalUser.text;
      }
    },
    // 許可ボタン押下時
    handlePermission() {
      //検索キーワード
      this.sortDeniedList
        .filter((e) => e.selected)
        .forEach((e) => {
          e.permission = true;
          e.selected = false;
        });
    },
    // 拒否ボタン押下時
    handleDenied() {
      //検索キーワード
      this.sortPermissionList
        .filter((e) => e.selected)
        .forEach((e) => {
          e.permission = false;
          e.selected = false;
        });
    },
    // 通知先情報の削除ボタン押下時
    handleDeleteNotify(index) {
      // 通知先が2件以上登録されていた場合、指定行を削除
      if (this.mailAddressList.length > 1) {
        this.mailAddressList.splice(index, 1);
        this.isErrorNotifyMail.splice(index, 1);
      }
      // 1件の場合はデータのみを削除
      else {
        this.mailAddressList[index].Address = "";
        this.mailAddressList[index].DisplayName = "";
        this.isErrorNotifyMail[index] = false;
      }
    },
    // メールアドレスの追加ボタン押下
    handleAddNotify() {
      this.mailAddressList.push({
        Address: "",
        DisplayName: "",
      });
      this.isErrorNotifyMail.push(false);
    },
    // 登録ボタン押下
    handleAdd() {
      // エラースタイルの初期化
      this.errorStyleInit();
      // エラー情報の初期化
      this.errors = [];
      this.errors_bopcode = [];
      this.errors_bopkana = [];
      this.errors_bopName = [];
      this.errors_closing = [];
      this.errors_corporatenumber = [];
      this.errors_postalCode = [];
      this.errors_addressF = [];
      this.errors_eLtaxId = [];
      this.errors_address = [];
      this.errors_mailAdd = [];
      this.errors_RepresentativeName = [];
      this.errors_RepresentativeAddress = [];
      this.errors_E_taxUserID = [];
      this.errors_E_taxPassword = [];
      this.errors_eLtaxPassword = [];

      // 事業者コード
      // 必須チェック
      if (!this.bopCode && this.bopCode !== 0) {
        this.isErrorBopCode = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_bopcode || this.errors_bopcode.length == 0) {
          this.errors_bopcode.push(
            Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", ["事業者コード"])
            )
          );
        }
      } else {
        // 半角英数チェック
        if (!Validation.checkCharType(this.bopCode, "alphanumeric")) {
          this.isErrorBopCode = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_bopcode || this.errors_bopcode.length == 0) {
            this.errors_bopcode.push(
              Common.createError(
                "MTCL1004",
                Common.getMessage("MTCL1004", ["事業者コード"])
              )
            );
          }
        }
      }
      // 事業者名（フリガナ）
      // 全角カタカナチェック
      if (this.bopNameKana) {
        if (!Validation.checkCharType(this.bopNameKana, "katakana")) {
          this.isErrorBopNameKana = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_bopkana || this.errors_bopkana.length == 0) {
            this.errors_bopkana.push(
              Common.createError(
                "MTCL1007",
                Common.getMessage("MTCL1007", ["事業者名（フリガナ）"])
              )
            );
          }
        }
      }
      // 事業者名
      // 必須チェック
      if (!this.bopName && this.bopName !== 0) {
        this.isErrorBopName = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_bopName || this.errors_bopName.length == 0) {
          this.errors_bopName.push(
            Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", ["事業者名"])
            )
          );
        }
      }
      // 入力禁止文字チェック
      if (
        !Validation.checkNationalkinsokuchar(this.bopName) ||
        !Validation.CheckFileNameInvalid(this.bopName)
      ) {
        this.isErrorBopName = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_bopName || this.errors_bopName.length == 0) {
          this.errors_bopName.push(
            Common.createError(
              "MTCL1098",
              Common.getMessage("MTCL1098", ["事業者名"])
            )
          );
        }
      }
      // 決算日(月)_相関チェック
      this.checkclosingDate();
      if (!this.isCheckClosingDate) {
        this.isErrorClosingMonth = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_closing || this.errors_closing.length == 0) {
          this.errors_closing.push(
            Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", ["決算日"])
            )
          );
        }
      }
      // 決算日(日)_相関チェック
      this.checkclosingDate();
      if (!this.isCheckClosingDate) {
        this.isErrorClosingDay = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_closing || this.errors_closing.length == 0) {
          this.errors_closing.push(
            Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", ["決算日"])
            )
          );
        }
      }
      // 主担当者チェック
      if (this.$refs.STDSDC02C09PersonInChargeModal.validate()) {
        this.isErrorPersonInCharge = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
      }
      // 法人番号チェック(法人の場合)
      if (this.rdoCorporationDivision && this.rdoCorporationDivision == 1) {
        if (this.corporateNumber) {
          // 半角チェック
          if (
            !Validation.isNumeric(this.corporateNumber.trim().replace(/-/g, ""))
          ) {
            this.isErrorCorporateNumber = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError(
                  "MTCL1119",
                  Common.getMessage("MTCL1119", [])
                )
              );
            }
            if (
              !this.errors_corporatenumber ||
              this.errors_corporatenumber.length == 0
            ) {
              this.errors_corporatenumber.push(
                Common.createError(
                  "MTCL1006",
                  Common.getMessage("MTCL1006", ["法人番号"])
                )
              );
            }
          }
          // 入力形式チェック
          else if (!(this.corporateNumber.length == 16)) {
            this.isErrorCorporateNumber = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError(
                  "MTCL1119",
                  Common.getMessage("MTCL1119", [])
                )
              );
            }
            if (
              !this.errors_corporatenumber ||
              this.errors_corporatenumber.length == 0
            ) {
              this.errors_corporatenumber.push(
                Common.createError(
                  "MTCL1009",
                  Common.getMessage("MTCL1009", ["法人番号", "13"])
                )
              );
            }
          }
          // 法人番号正確性チェック
          // 法人番号の1桁目=9-((2,4,6,8,10,12桁目の和)*2+(3,5,7,9,11,13桁目の和))/9の余り
          else {
            if (!Validation.checkCorporateNumber(this.corporateNumber)) {
              this.isErrorCorporateNumber = true;
              if (!this.errors || this.errors.length == 0) {
                this.errors.push(
                  Common.createError(
                    "MTCL1119",
                    Common.getMessage("MTCL1119", [])
                  )
                );
              }
              if (
                !this.errors_corporatenumber ||
                this.errors_corporatenumber.length == 0
              ) {
                this.errors_corporatenumber.push(
                  Common.createError(
                    "MTCL1130",
                    Common.getMessage("MTCL1130", ["法人番号"])
                  )
                );
              }
            }
          }
        }
      }
      // 郵便番号半角数字チェック
      // 郵便番号3桁
      if (this.zipCode1) {
        // 半角英数チェック
        if (!Validation.checkCharType(this.zipCode1, "numeric")) {
          this.isErrorPostalCode3 = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_postalCode || this.errors_postalCode.length == 0) {
            this.errors_postalCode.push(
              Common.createError(
                "MTCL1006",
                Common.getMessage("MTCL1006", ["郵便番号"])
              )
            );
          }
        }
        // 3桁数チェック
        if (this.zipCode1.length != 3) {
          this.isErrorPostalCode3 = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_postalCode || this.errors_postalCode.length == 0) {
            this.errors_postalCode.push(
              Common.createError(
                "MTCL1009",
                Common.getMessage("MTCL1009", ["郵便番号1", "3"])
              )
            );
          }
        }
      }
      // 郵便番号4桁
      if (this.zipCode2) {
        // 半角英数チェック
        if (!Validation.checkCharType(this.zipCode2, "numeric")) {
          this.isErrorPostalCode4 = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_postalCode || this.errors_postalCode.length == 0) {
            this.errors_postalCode.push(
              Common.createError(
                "MTCL1006",
                Common.getMessage("MTCL1006", ["郵便番号"])
              )
            );
          }
        }
        // 4桁数チェック
        if (this.zipCode2.length != 4) {
          this.isErrorPostalCode4 = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_postalCode || this.errors_postalCode.length == 0) {
            this.errors_postalCode.push(
              Common.createError(
                "MTCL1009",
                Common.getMessage("MTCL1009", ["郵便番号2", "4"])
              )
            );
          }
        }
      }

      // 所在地（フリガナ）
      // 全角カタカナチェック
      if (this.addressF || this.addressF === 0) {
        if (
          !Validation.checkCharType(this.addressF, "zenkaku-numeric-katakana")
        ) {
          this.isErrorAddressF = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_addressF || this.errors_addressF.length == 0) {
            this.errors_addressF.push(
              Common.createError(
                "MTCL1007",
                Common.getMessage("MTCL1007", ["所在地（フリガナ）"])
              )
            );
          }
        }
      }
      // 所在地
      // 入力禁止文字チェック(所在地)
      if (this.address !== "") {
        if (!Validation.checkNationalkinsokuchar(this.address)) {
          this.isErrorAddress = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_address || this.errors_address.length == 0) {
            this.errors_address.push(
              Common.createError(
                "MTCL1098",
                Common.getMessage("MTCL1098", ["所在地"])
              )
            );
          }
        }
      }

      // 郵便番号・所在地
      // エラー表示クリアのチェック
      if (
        Validation.isOneRequired(this.zipCode1, this.address) ||
        (this.zipCode1 == "" && this.address == "")
      ) {
        // エラー表示の初期化
        this.isErrorOneRequired = false;
        this.errors_oneRequired = [];
        //別の項目はエラーではない場合、エラーメッセージ領域をクリア
        if (!this.isTopErrorShow && !this.isErrorOneRequired) {
          this.errors = [];
        }
      }

      // 代表者氏名
      // 入力禁止文字チェック(代表者氏名)
      if (this.representativeName !== "") {
        if (
          !Validation.checkNationalkinsokuchar(this.representativeName) ||
          !Validation.CheckFileNameInvalid(this.representativeName)
        ) {
          this.isErrorRepresentativeName = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (
            !this.errors_RepresentativeName ||
            this.errors_RepresentativeName.length == 0
          ) {
            this.errors_RepresentativeName.push(
              Common.createError(
                "MTCL1098",
                Common.getMessage("MTCL1098", ["代表者氏名"])
              )
            );
          }
        }
      }

      // 代表者住所
      // 入力禁止文字チェック(代表者住所)
      if (this.representativeAddress !== "") {
        if (
          !Validation.checkNationalkinsokuchar(this.representativeAddress) ||
          !Validation.CheckFileNameInvalid(this.representativeAddress)
        ) {
          this.isErrorRepresentativeAddress = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (
            !this.errors_RepresentativeAddress ||
            this.errors_RepresentativeAddress.length == 0
          ) {
            this.errors_RepresentativeAddress.push(
              Common.createError(
                "MTCL1098",
                Common.getMessage("MTCL1098", ["代表者住所"])
              )
            );
          }
        }
      }

      // 所轄税務署
      // 入力禁止文字チェック(所轄税務署)
      if (!this.$refs.refSTDSDC01C11TaxOfficeListModal.validate()) {
        this.isErrorCompetentTaxOffice = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
      }

      // 利用者識別番号(e-Tax)
      if (this.e_taxUserID !== "") {
        // 半角数字チェック
        if (!Validation.isNumeric(this.e_taxUserID)) {
          this.isErrorE_taxUserID = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_E_taxUserID || this.errors_E_taxUserID.length == 0) {
            this.errors_E_taxUserID.push(
              Common.createError(
                "MTCL1006",
                Common.getMessage("MTCL1006", ["利用者識別番号(e-Tax)"])
              )
            );
          }
        }
        // 文字列長チェック
        else {
          if (!(this.e_taxUserID.replace(/-/g, "").length == 16)) {
            this.isErrorE_taxUserID = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError(
                  "MTCL1119",
                  Common.getMessage("MTCL1119", [])
                )
              );
            }
            if (
              !this.errors_E_taxUserID ||
              this.errors_E_taxUserID.length == 0
            ) {
              this.errors_E_taxUserID.push(
                Common.createError(
                  "MTCL1009",
                  Common.getMessage("MTCL1009", ["利用者識別番号(e-Tax)", "16"])
                )
              );
            }
          }
        }
      }

      // 暗証番号(e-Tax)
      if (this.e_taxPassword !== "") {
        // 半角英数チェック
        const regDigitAndLeter = /^(?=.*\d)(?=.*[A-Za-z]).+$/;
        const allowedPattern = /^[a-zA-Z0-9!/=+:#,@$%._-]+$/;
        if (!allowedPattern.test(this.e_taxPassword)) {
          this.isErrorE_taxPassword = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (
            !this.errors_E_taxPassword ||
            this.errors_E_taxPassword.length == 0
          ) {
            this.errors_E_taxPassword.push(
              Common.createError(
                "MTCL1173",
                Common.getMessage("MTCL1173", ["暗証番号(e-Tax)"])
              )
            );
          }
        }
        // 半角英字・半角数字をそれぞれ1文字以上含むことチェック
        else if (!regDigitAndLeter.test(this.e_taxPassword)) {
          this.isErrorE_taxPassword = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (
            !this.errors_E_taxPassword ||
            this.errors_E_taxPassword.length == 0
          ) {
            this.errors_E_taxPassword.push(
              Common.createError(
                "MTCL1173",
                Common.getMessage("MTCL1173", ["暗証番号(e-Tax)"])
              )
            );
          }
        }
        // 最小文字数チェック
        else if (!(this.e_taxPassword.length >= 8)) {
          this.isErrorE_taxPassword = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (
            !this.errors_E_taxPassword ||
            this.errors_E_taxPassword.length == 0
          ) {
            this.errors_E_taxPassword.push(
              Common.createError(
                "MTCL1013",
                Common.getMessage("MTCL1013", ["暗証番号(e-Tax)", "8"])
              )
            );
          }
        }
        // 最大文字数チェック
        else {
          if (!(this.e_taxPassword.length <= 50)) {
            this.isErrorE_taxPassword = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError(
                  "MTCL1119",
                  Common.getMessage("MTCL1119", [])
                )
              );
            }
            if (
              !this.errors_E_taxPassword ||
              this.errors_E_taxPassword.length == 0
            ) {
              this.errors_E_taxPassword.push(
                Common.createError(
                  "MTCL1014",
                  Common.getMessage("MTCL1014", ["暗証番号(e-Tax)", "50"])
                )
              );
            }
          }
        }
      }

      // 利用者ID(eLTAX)
      if (this.eLtaxId != "") {
        // 半角英数チェック
        if (!Validation.checkCharType(this.eLtaxId, "alphanumeric")) {
          this.isErrorELtaxId = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_eLtaxId || this.errors_eLtaxId.length == 0) {
            this.errors_eLtaxId.push(
              Common.createError(
                "MTCL1004",
                Common.getMessage("MTCL1004", ["利用者ID(eLTAX)"])
              )
            );
          }
        } // 文字列長チェック
        else if (this.eLtaxId.length != 11) {
          this.isErrorELtaxId = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_eLtaxId || this.errors_eLtaxId.length == 0) {
            this.errors_eLtaxId.push(
              Common.createError(
                "MTCL1004",
                Common.getMessage("MTCL1009", ["利用者ID(eLTAX)", "11"])
              )
            );
          }
        }
      }

      // 暗証番号(eLTax)
      if (this.eLtaxPassword !== "") {
        // 半角英数チェック
        const allowedPattern = /^[a-zA-Z0-9!/=+:#,@$%._-]+$/;
        if (!allowedPattern.test(this.eLtaxPassword)) {
          this.isErrorELtaxPassword = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (
            !this.errors_eLtaxPassword ||
            this.errors_eLtaxPassword.length == 0
          ) {
            this.errors_eLtaxPassword.push(
              Common.createError(
                "MTCL1173",
                Common.getMessage("MTCL1173", ["暗証番号(eLTAX)"])
              )
            );
          }
        }
        // 最小文字数チェック
        else if (!(this.eLtaxPassword.length >= 8)) {
          this.isErrorELtaxPassword = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (
            !this.errors_eLtaxPassword ||
            this.errors_eLtaxPassword.length == 0
          ) {
            this.errors_eLtaxPassword.push(
              Common.createError(
                "MTCL1013",
                Common.getMessage("MTCL1013", ["暗証番号(eLTAX)", "8"])
              )
            );
          }
        }
        // 最大文字数チェック
        else {
          if (!(this.eLtaxPassword.length <= 16)) {
            this.isErrorELtaxPassword = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError(
                  "MTCL1119",
                  Common.getMessage("MTCL1119", [])
                )
              );
            }
            if (
              !this.errors_eLtaxPassword ||
              this.errors_eLtaxPassword.length == 0
            ) {
              this.errors_eLtaxPassword.push(
                Common.createError(
                  "MTCL1014",
                  Common.getMessage("MTCL1014", ["暗証番号(eLTAX)", "50"])
                )
              );
            }
          }
        }
      }

      // 通知先メールアドレスチェック
      this.mailAddressList.forEach((element, index) => {
        // メール形式チェック
        if (element.Address && !Validation.isMail(element.Address)) {
          this.isErrorNotifyMail[index] = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_mailAdd || this.errors_mailAdd.length == 0) {
            this.errors_mailAdd.push(
              Common.createError(
                "MTCL1015",
                Common.getMessage("MTCL1015", [
                  "税理士事務所メールアドレス情報のメールアドレス",
                ])
              )
            );
          }
        }
        // 宛先名が入力されている場合
        if (element.DisplayName || element.DisplayName === 0) {
          // メールアドレス必須チェック
          if (!element.Address) {
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError(
                  "MTCL1119",
                  Common.getMessage("MTCL1119", [])
                )
              );
            }
            if (!this.errors_mailAdd || this.errors_mailAdd.length == 0) {
              this.errors_mailAdd.push(
                Common.createError(
                  "MTCL1021",
                  Common.getMessage("MTCL1021", [])
                )
              );
            }
            var index = this.mailAddressList.findIndex(
              (item) =>
                item.address == element.address &&
                item.DisplayName == element.DisplayName
            );
            this.isErrorNotifyMail[index] = true;
          }
        }
      });

      // エラーが発生していなければ登録処理のAPIを実行
      if (!this.errors || this.errors.length == 0) {
        if (this.isAccessPermission == "0") {
          this.authorityInfoList
            .filter((e) => e.enabled)
            .forEach((info) => {
              info.permission = true;
            });
        }
        let paramWorkgroupList = [];
        let paramUserList = [];
        this.workgroupList.forEach((value, index, array) => {
          if (
            this.authorityInfoList.filter(
              (val) =>
                val.authority === 0 &&
                val.keyName === value.keyName &&
                val.id === value.workgroupCode &&
                val.permission
            ).length > 0
          ) {
            paramWorkgroupList.push(value);
          }
        });
        this.userList.forEach((value, index, array) => {
          if (
            this.authorityInfoList.filter(
              (val) =>
                (val.authority === 2 || val.authority === 3) &&
                val.keyName === value.keyName &&
                val.id === value.id &&
                val.permission
            ).length > 0
          ) {
            paramUserList.push(value);
          }
        });

        let mailList = this.mailAddressList.filter((item) => {
          return item.Address;
        });

        // 登録パラメータ
        const param = {
          BusinessOperatorCode: this.bopCode,
          BusinessOperatorType: this.rdoCorporationDivision,
          BusinessOperatorNameF: this.bopNameKana,
          BusinessOperatorName: this.bopName,
          AccountClosingMonth: this.closingMonth,
          AccountClosingDay: this.closingDay,
          PersonInCharge:
            this.$refs.STDSDC02C09PersonInChargeModal.getRadioFlag()
              ? this.personInChargeList.find((e) => e.id == this.personInCharge)
              : null,
          CorporateNumber: this.corporateNumbertemp.trim().replace(/-/g, ""),
          ZipCode1: this.zipCode1,
          ZipCode2: this.zipCode2,
          AddressF: this.addressF,
          Address: this.address,
          representativeName: this.representativeName,
          representativeAddress: this.representativeAddress,
          etaxUserId: this.e_taxUserID,
          etaxPassword: this.e_taxPassword,
          ELtaxId: this.eLtaxId,
          ELtaxPassword: this.eLtaxPassword,
          CompetentTaxOffice: this.competentTaxOffice,
          WorkgroupList: paramWorkgroupList,
          UserList: paramUserList,
          MailAddressList: mailList,
          accessAuthoritySettingMode: this.isAccessPermission,
        };

        this.toRouter = "STDSDC02C01";

        this.isDisabled = true;
        API_AddBopInfo(param).then((response) => {
          // 正常終了の場合、事業者コードを事業者情報TOP画面に返す
          if (response.result == "0000") {
            this.$router.push({
              name: "STDSDC02C01",
              state: { businessOperatorCode: this.bopCode },
            });
          } else if (response.result == "1500") {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          } else if (
            response.result == "0100" &&
            response.errorCD != "MTCL1021"
          ) {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [response.errorName[0]])
              )
            );
          } else {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
          this.isDisabled = false;
        });
      }
    },
    // エラースタイルを初期化する
    errorStyleInit() {
      this.isErrorBopCode = false;
      this.isErrorBopNameKana = false;
      this.isErrorBopName = false;
      this.isErrorClosingMonth = false;
      this.isErrorClosingDay = false;
      this.isErrorPersonInCharge = false;
      this.isErrorCorporateNumber = false;
      this.isErrorPostalCode3 = false;
      this.isErrorPostalCode4 = false;
      this.isErrorAddressF = false;
      this.isErrorAddress = false;
      this.isErrorRepresentativeName = false;
      this.isErrorRepresentativeAddress = false;
      this.isErrorE_taxUserID = false;
      this.isErrorE_taxPassword = false;
      this.isErrorELtaxId = false;
      this.isErrorELtaxPassword = false;
      this.isErrorCompetentTaxOffice = false;
      this.mailAddressList.forEach((value, index, array) => {
        this.isErrorNotifyMail[index] = false;
      });
    },
    toggleRadio() {
      this.rdoCorporationDivision = this.rdoCorporationDivision == 1 ? 2 : 1;
      const focusableRadios = this.$refs.content.querySelectorAll(
        'span[tabindex]:not([tabindex="-1"])'
      );
      const el = [...focusableRadios][this.rdoCorporationDivision == 1 ? 0 : 1];
    },
    toggleRadioAccessPermission() {
      this.isAccessPermission = this.isAccessPermission == 0 ? 1 : 0;
    },
    // 決算日_相関チェック
    checkclosingDate() {
      this.isCheckClosingDate = true;
      if (!this.closingMonth && this.closingMonth !== 0) {
        this.isCheckClosingDate = false;
      } else if (this.closingMonth.length > 2) {
        this.isCheckClosingDate = false;
      } else if (!Validation.checkBetween(this.closingMonth, 1, 12)) {
        this.isCheckClosingDate = false;
      } else if (!this.closingDay && this.closingDay !== 0) {
        this.isCheckClosingDate = false;
      } else if (this.closingDay.length > 2) {
        this.isCheckClosingDate = false;
      } else if (!Validation.checkBetween(this.closingDay, 1, 31)) {
        this.isCheckClosingDate = false;
      } else if (!Validation.verifyDateMD(this.closingMonth, this.closingDay)) {
        this.isCheckClosingDate = false;
      }
    },
    // **********************************************
    // 法人番号参照
    // **********************************************
    corporateNoSiteUrl() {
      window.open(
        Common.getSettingsValue("CorporateNoPublicationSiteUrl"),
        "_blank",
        "width=1238,height=1282,menubar=no,address=no,resizable=yes,scrollbars=yes,status=no"
      );
    },

    // **********************************************
    // 郵便番号3桁、所在地　入力チェック
    // **********************************************
    isAddressListModalShowCheck() {
      // エラー表示の初期化
      this.isErrorPostalCode3 = false;
      this.isErrorPostalCode4 = false;
      this.isErrorOneRequired = false;
      this.errors_oneRequired = [];
      this.errors_postalCode = [];
      //別の項目はエラーではない場合、エラーメッセージ領域をクリア
      if (!this.isTopErrorShow && !this.isErrorOneRequired) {
        this.errors = [];
      }
      // いずれかが入力されているチェック
      if (!Validation.isOneRequired(this.zipCode1, this.address)) {
        this.isErrorOneRequired = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_oneRequired || this.errors_oneRequired.length == 0) {
          this.errors_oneRequired.push(
            Common.createError(
              "MTCL1128",
              Common.getMessage("MTCL1128", ["所在地", "所在地を入力"])
            )
          );
        }
        return false;
      }
      // 郵便番号3桁
      if (this.zipCode1) {
        // 半角英数チェック
        if (!Validation.checkCharType(this.zipCode1, "numeric")) {
          this.isErrorPostalCode3 = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_postalCode || this.errors_postalCode.length == 0) {
            this.errors_postalCode.push(
              Common.createError(
                "MTCL1006",
                Common.getMessage("MTCL1006", ["郵便番号"])
              )
            );
          }
          return false;
        }
        // 3桁数チェック
        if (!(this.zipCode1.length == 3)) {
          this.isErrorPostalCode3 = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_postalCode || this.errors_postalCode.length == 0) {
            this.errors_postalCode.push(
              Common.createError(
                "MTCL1009",
                Common.getMessage("MTCL1009", ["郵便番号1", "3"])
              )
            );
          }
          return false;
        }
      }
      // 郵便番号4桁
      if (this.zipCode2) {
        // 半角英数チェック
        if (!Validation.checkCharType(this.zipCode2, "numeric")) {
          this.isErrorPostalCode4 = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_postalCode || this.errors_postalCode.length == 0) {
            this.errors_postalCode.push(
              Common.createError(
                "MTCL1006",
                Common.getMessage("MTCL1006", ["郵便番号"])
              )
            );
          }
          return false;
        }
      }
      return true;
    },
    // **********************************************
    // 郵便番号参照ボタンを押す
    // **********************************************
    addressSearch() {
      // 郵便番号3桁、住所・都道府県　入力チェック
      if (!this.isAddressListModalShowCheck()) {
        return;
      }
      // address 住所・都道府県+住所・市区町村+住所・丁目・番地等
      // スペースをカットして、半角カタカナが含まれている場合、全角カタカナに変換する。
      const address = Common.halfAlpNum2FullAlpNum(
        Common.halfWidth2FullWidthKana(
          Common.removeSpaces(this.address ? this.address : "")
        )
      );
      const param = {
        zipCode1: this.zipCode1,
        zipCode2: this.zipCode2,
        address: address,
      };
      this.processDialogue(true);
      // 住所検索行い
      API_SearchAddressList_NetCommon(param)
        .then((response) => {
          if (response.result == "0000") {
            const addressList = response.addressData;
            // 正常かつ0件
            if (addressList.length === 0) {
              this.isErrorOneRequired = true;
              this.errors_oneRequired.push(
                Common.createError(
                  "MTCL1129",
                  Common.getMessage("MTCL1129", ["所在地"])
                )
              );
              if (!this.errors || this.errors.length == 0) {
                this.errors.push(
                  Common.createError(
                    "MTCL1119",
                    Common.getMessage("MTCL1119", [])
                  )
                );
              }
            } else if (addressList.length === 1) {
              const address = addressList[0];
              // 郵便番号設定
              this.zipCode1 = address.zipCode1;
              this.zipCode2 = address.zipCode2;
              this.address = param.address?.includes(address.address)
                ? this.address
                : address.address;
              this.handleSearchLocationInput(address.addressF);
              // 住所設定 TODO
            }
            // 正常かつ複数件
            else if (addressList.length > 1) {
              this.addressList = addressList;
              this.isAddressListModalShow = true;
            }
          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        })
        .finally(() => {
          this.processDialogue(false);
        });
    },
    // **********************************************
    // STDSDC01C12郵便番号確定
    // **********************************************
    confirmSTDSDC01C12(item) {
      // address 住所・都道府県+住所・市区町村+住所・丁目・番地等
      // スペースをカットして、半角カタカナが含まれている場合、全角カタカナに変換する。
      const address = Common.halfAlpNum2FullAlpNum(
        Common.halfWidth2FullWidthKana(
          Common.removeSpaces(this.address ? this.address : "")
        )
      );
      this.zipCode1 = item.zipCode1;
      this.zipCode2 = item.zipCode2;
      this.address = address?.includes(item.address)
        ? this.address
        : item.address;
      this.handleSearchLocationInput(item.addressF);
      this.isAddressListModalShow = false;
    },
    // **********************************************
    // STDSDC01C12郵便番号キャンセル
    // **********************************************
    cancelSTDSDC01C12() {
      // 遷移チェック：「キャンセル」
      this.isAddressListModalShow = false;
    },
    // フリガナを入力する
    async handleSearchLocationInput(input) {
      let katakana = await onlyKatakanaAndFullWithNumber(input);
      const maxLengthKataKana = String(katakana).slice(0, 160);
      this.addressF = "";
      this.addressF = maxLengthKataKana;
    },
    formatE_taxUserID(event) {
      this.e_taxUserID = event.target.value.replace(/-/g, "");
    },
    formatWithHyphens(value) {
      // Remove existing hyphens (null/undefined安全対応)
      const cleanedValue =
        typeof value === "string" ? value.replace(/-/g, "") : "";
      // Insert hyphens every 4 characters
      const formattedValue = cleanedValue.replace(/(.{4})/g, "$1-");
      // Remove the trailing hyphen if present
      return formattedValue.endsWith("-")
        ? formattedValue.slice(0, -1)
        : formattedValue;
    },
  },
};
</script>
